import { render, staticRenderFns } from "./SitchModal.vue?vue&type=template&id=3f6cd34c&scoped=true&"
import script from "./SitchModal.vue?vue&type=script&lang=ts&"
export * from "./SitchModal.vue?vue&type=script&lang=ts&"
import style0 from "./SitchModal.vue?vue&type=style&index=0&id=3f6cd34c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6cd34c",
  null
  
)

export default component.exports